import { IIconProps } from '@cian/ui-kit-design-tokens/internal/types';
import * as React from 'react';

export const IconAgent24 = ({ color }: IIconProps) => {
  const currentColor = color ? `var(--${color})` : 'currentColor';

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g fill={currentColor}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 5h5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-7v-3H9v3H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3ZM9 5h6V3H9v2Z"
        />
        <path d="M15 19v-2h7v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5h7v2h6Z" />
      </g>
    </svg>
  );
};
